<template>
  <div class="inbox">
    <v-alert
      v-if="forced"
      class="mt-2"
      text
      dense
      color="teal"
      icon="mdi-comment-alert-outline"
      border="left"
    >
      <span
        >شما حداقل یک پیام سیستمی دارید. برای استفاده از سایت باید آنها را
        مشاهده نمایید.</span
      >
    </v-alert>
    <message-list :messages="messages" @refresh="GetForcedInboxCount" />
  </div>
</template>

<script>
import ResultType from "../../model/ResultType";
import MessageList from "./MessageList.vue";
export default {
  components: { MessageList },
  data() {
    return {
      messages: [],
      forced: false,
    };
  },
  mounted() {
    this.GetForcedInboxCount();
  },
  methods: {
    GetForcedInboxCount() {
      this.$store.dispatch("GetForcedInboxCount").then((result) => {
        console.log(result);
        if (result.type === ResultType.success) {
          if (result.data > 0) {
            this.$store.commit("setDisableSideMenu", true);
            this.forced = true;
            this.GetForcedInbox();
          } else {
            this.$store.commit("setDisableSideMenu", false);
            this.forced = false;
            this.GetInbox();
          }
        }
      });
    },
    GetForcedInbox() {
      this.$store.dispatch("GetForcedInbox").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.messages = result.data.Table;
        }
      });
    },
    GetInbox() {
      this.$store.dispatch("GetInbox").then((result) => {
        if (result.type === ResultType.success) {
          this.messages = result.data.Table;
        }
      });
    },
  },
};
</script>

<style>
</style>